import { Amplify } from 'aws-amplify';
import { signIn as amplifySignIn, fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';
import { LoginResponseType } from '../../types';

// import { signIn } from 'aws-amplify/auth';

// await signIn({
//   username: 'your-username',
//   password: 'your-password'
// });

// 使用するユーザープール、クライアントの ID を指定
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID!,
      userPoolClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID!
    }
  }
});

export const signIn = async (email: string, password: string): Promise<LoginResponseType> => {
  console.log('LoginFunc_signIn.開始');
  // console.log('email:', email);
  // console.log('password:', password);
  try {
    // 既にログインしているか確認
    try {
      const user = await getCurrentUser();
      const session = await fetchAuthSession();
      // console.log('tokens:', session.tokens);
      // console.log('accessToken raw:', session.tokens?.accessToken);
      // console.log('accessToken string:', session.tokens?.accessToken?.toString());
      // console.log('payload:', session.tokens?.accessToken?.payload);
      // console.log('session:', session);
      // console.log('LoginFunc_signIn.頭で既にログイン済みです');

      return {
        statusCode: 200,
        message: 'すでにログイン済みです',
        mailAddress: user.signInDetails?.loginId ?? email,
        // accessToken: session.tokens?.idToken?.toString() ?? ''
        // こちらが正しい
        accessToken: session.tokens?.accessToken?.toString() ?? ''
      };
    } catch {
      // 未ログインなら通常ログイン処理へ
      console.log('LoginFunc_signIn.未ログインのため、通常のログイン処理を行います');
    }

    const signInResult = await amplifySignIn({ username: email, password });

    if (!signInResult.isSignedIn) {
      // console.log('LoginFunc_signIn.サインインしている');
      return {
        statusCode: 400,
        message: 'ログインに失敗しました',
        mailAddress: '',
        accessToken: ''
      };
    }

    const session = await fetchAuthSession({ forceRefresh: true });
    // session.idToken;
    const user = await getCurrentUser();

    // console.log('LoginFunc_signIn.成功');
    // console.log(session);

    return {
      statusCode: 200,
      message: 'ログインに成功しました',
      mailAddress: user.signInDetails?.loginId ?? email,
      accessToken: session.tokens?.accessToken?.toString() ?? ''
    };
  } catch (error) {
    // console.log('LoginFunc_signIn.失敗');
    // console.log(error);
    return {
      statusCode: 400,
      message: 'ログインに失敗しました',
      mailAddress: '',
      accessToken: ''
    };
  }
};
